module.exports = __webpack_public_path__ + "img/3_18.60648000.png";